module.exports = __webpack_public_path__ + "img/13-small.3892a3a4.png";